function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2699 10.55C12.6499 10.55 14.6399 8.54999 14.6399 6.17999C14.6399 3.80999 12.6399 1.81 10.2699 1.81C7.8999 1.81 5.8999 3.80999 5.8999 6.17999C5.8999 8.54999 7.7999 10.55 10.2699 10.55Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3401 18.96C13.3601 18.53 13.5001 18.25 13.8001 18.05C13.8801 18 13.9701 17.95 14.0501 17.9C14.4601 17.63 14.4601 17.04 14.0501 16.78C13.9701 16.73 13.8901 16.69 13.8101 16.63C13.3801 16.35 13.2301 15.79 13.4601 15.34C13.5801 15.11 13.7101 14.89 13.8501 14.67C14.1301 14.24 14.6801 14.09 15.1401 14.32C15.2801 14.39 15.4201 14.48 15.5801 14.52C15.9701 14.61 16.3501 14.31 16.3701 13.9C16.3701 13.79 16.3701 13.67 16.3801 13.56C16.4401 13.08 16.7701 12.73 17.2501 12.68C17.5601 12.65 17.8901 12.65 18.2001 12.68C18.6801 12.74 19.0301 13.14 19.0501 13.63C19.0501 13.71 19.0501 13.79 19.0501 13.87C19.0601 14.39 19.5801 14.69 20.0401 14.45C20.2001 14.37 20.3701 14.28 20.5401 14.23C20.9301 14.14 21.3401 14.31 21.5501 14.65C21.7001 14.88 21.8301 15.11 21.9601 15.35C22.1901 15.8 22.0401 16.34 21.6201 16.62C21.5501 16.67 21.4701 16.71 21.4001 16.75C20.9301 17.03 20.9401 17.64 21.4001 17.93C21.4701 17.97 21.5401 18.01 21.6001 18.05C22.0301 18.33 22.1801 18.88 21.9501 19.34C21.8301 19.57 21.7001 19.79 21.5601 20.01C21.2801 20.44 20.7301 20.59 20.2701 20.36C20.1301 20.29 19.9901 20.2 19.8301 20.16C19.4401 20.07 19.0601 20.38 19.0401 20.78C19.0401 20.89 19.0401 21.01 19.0301 21.12C18.9701 21.6 18.6401 21.95 18.1601 22C17.8501 22.03 17.5201 22.03 17.2101 22C16.7101 21.94 16.3701 21.53 16.3601 21.03C16.3601 20.92 16.3601 20.81 16.3501 20.7C16.2701 20.25 15.7901 20.02 15.3801 20.23C15.2101 20.31 15.0501 20.41 14.8701 20.45C14.4501 20.54 14.1001 20.39 13.8601 20.03C13.7101 19.81 13.5801 19.57 13.4601 19.33C13.3901 19.2 13.3701 19.04 13.3501 18.97L13.3401 18.96Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.71 16.01C18.44 16.01 19.04 16.61 19.03 17.34C19.03 18.07 18.43 18.66 17.7 18.66C16.97 18.66 16.37 18.06 16.38 17.33C16.38 16.6 16.98 16.01 17.71 16.01Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0801 13.52C11.4901 13.49 10.8901 13.47 10.2701 13.47C5.98011 13.47 2.36011 14.13 2.36011 16.66C2.36011 19.19 5.99011 19.85 10.2701 19.85C10.6501 19.85 11.0201 19.85 11.3901 19.83",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgAdminUsers = function SvgAdminUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdminUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adminUsers.747ceb20.svg";
export { ForwardRef as ReactComponent };